'use strict';

document.addEventListener('DOMContentLoaded', () => {
	document.body.addEventListener('click', (e) => {
		if (e.target.closest('[data-href]')) {
			const dataRef = e.target.getAttribute('data-href');
			window.open(dataRef, '_blank');
		}
	});
});